import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_CONFIG from '../../config/api';

export const fetchCategories = createAsyncThunk(
  'categories/fetchCategories',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('auth_token')}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data.categories;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchSubcategories = createAsyncThunk(
  'categories/fetchSubcategories',
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_CONFIG.BASE_URL}/subcategories/${categoryId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('auth_token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data.subcategories;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchAllSubcategories = createAsyncThunk(
  'categories/fetchAllSubcategories',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_CONFIG.BASE_URL}/all-subcategories`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('auth_token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data.subcategories;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    categories: [],
    subcategories: [],
    allSubcategories: [],
    loading: false,
    subLoading: false,
    allSubLoading: false,
    error: null,
    subError: null,
    allSubError: null,
    selectedCategoryId: null,
  },
  reducers: {
    clearSubcategories(state) {
      state.subcategories = [];
      state.selectedCategoryId = null;
    },
    clearAllSubcategories(state) {
      state.allSubcategories = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchSubcategories.pending, (state) => {
        state.subLoading = true;
        state.subError = null;
        state.subcategories = [];
      })
      .addCase(fetchSubcategories.fulfilled, (state, action) => {
        state.subLoading = false;
        state.subcategories = action.payload;
      })
      .addCase(fetchSubcategories.rejected, (state, action) => {
        state.subLoading = false;
        state.subError = action.payload;
      })

      .addCase(fetchAllSubcategories.pending, (state) => {
        state.allSubLoading = true;
        state.allSubError = null;
      })
      .addCase(fetchAllSubcategories.fulfilled, (state, action) => {
        state.allSubLoading = false;
        state.allSubcategories = action.payload;
      })
      .addCase(fetchAllSubcategories.rejected, (state, action) => {
        state.allSubLoading = false;
        state.allSubError = action.payload;
      });
  },
});

export const { clearSubcategories } = categoriesSlice.actions;
export default categoriesSlice.reducer;
